import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import AddEditFolderDialog from './AddEditFolderDialog';
import { useQueryClient } from '@tanstack/react-query';
import { filesOrFoldersKeys, FileScopeType } from './hooks/useGetAllFiles';

export type AddFolderButtonProps = { 
  className?: string;
  ownerId: string;
  scopeType?: FileScopeType;
  iconOnly?: boolean;
  iconLabel?: string;
};

const AddFolderButton: React.FC<AddFolderButtonProps> = ({
  className,
  ownerId,
  scopeType,
  iconOnly = false,
  iconLabel = 'Create folder',
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const queryClient = useQueryClient();

  const handleCreate = () => {
    queryClient.invalidateQueries({
      queryKey: filesOrFoldersKeys.allFiles(ownerId),
    });
    setShowDialog(false);
  };

  return (
    <>
      {iconOnly ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="add-folder-icon-tooltip">{iconLabel}</Tooltip>}
        >
          <button
            type="button"
            onClick={() => setShowDialog(true)}
            className="btn btn-link p-1 border-0 text-white"
            aria-label={iconLabel}
          >
            <i className="material-symbols-outlined">create_new_folder</i>
          </button>
        </OverlayTrigger>
      ) : (
        <StylishNewButton
          className={className}
          onClick={() => setShowDialog(true)}
        >
          Create Folder
        </StylishNewButton>
      )}
      {showDialog && (
        <AddEditFolderDialog
          onSuccess={handleCreate}
          onClose={() => setShowDialog(false)}
          dialogType={'Create'}
          ownerId={ownerId}
          scopeType={scopeType}
        />
      )}
    </>
  );
};

export default AddFolderButton;
